class save {

    constructor(cookie) {
        this.cookie = cookie;
        this.set_listeners();
    }

    get_short_url() {
        var self = this;

        return new Promise(function (resolve, reject) {
            var data = {};
            data.security = texts.security;
            data.action = 'fl_gasspring_configurator';
            data.sub_action = 'get_short_url';
            data.long_url = self.get_long_url();

            var xhr = $.ajax({
                url: texts.ajaxurl,
                data: data,
                type: 'post',
                success: function (results) {
                    resolve(location.protocol + '//' + location.host + location.pathname + "?l=" + results);
                },
                error: function (xhr, status, err) {
                    reject(err);
                }
            });
        });
    }

    get_encoded_cookie() {
        var data = this.get_share_cookie_data();

        return flbtoa(JSON.stringify(data));
    }

    /**
     * Build cookie payload for share links, ensuring ranked gas springs are included.
     *
     * @returns {Array|null}
     */
    get_share_cookie_data() {
        if (typeof cf !== 'undefined' && cf.sync_mounting_parts_to_form) {
            cf.sync_mounting_parts_to_form();
        }

        if (typeof cf !== 'undefined' && cf.sync_extender_to_form) {
            cf.sync_extender_to_form();
        }

        if (typeof cf !== 'undefined' && cf.cookie) {
            cf.cookie.set();
        }

        var data = this.cookie.get();

        if (!data || !Array.isArray(data)) {
            return data;
        }

        data = data.filter(function (item) {
            return item.name !== 'length_combis' && item.name !== 'gs_ranked';
        });

        if (typeof cf !== 'undefined' && cf.as && cf.as.sorted_length_combis.length > 0) {
            var gs_ranked = cf.as.build_gs_ranked_for_cookie(5);

            if (gs_ranked.length > 0) {
                data.push({
                    name: 'gs_ranked',
                    value: JSON.stringify(gs_ranked)
                });
            }
        }

        data = ensure_mounting_parts_cookie_fields(data);

        return ensure_extender_cookie_fields(data);
    }

    get_long_url() {
        return location.protocol + '//' + location.host + location.pathname + "?link=" + this.get_encoded_cookie();
    }

    do_email() {
        var self = this;
        alert(texts.linkmailentext);

        self.get_short_url().then(function (data) {
            var link = document.createElement("a");
            link.href = "mailto:" + texts.admin_email + "?subject=" + location.host + location.pathname + "&body=" + data;
            link.click();
        }).catch(function (err) {
            
        })
    }

    show_qr_code() {
        var self = this;

        self.get_short_url().then(function (data) {
            var qrcodeimg = '<a style="text-align: center;" href="' + texts.configurl + '"><img height="250" width="250" src="https://qrcode.featherlight.com/?c=' + encodeURI(data) + '"></a>';
            jQuery.colorbox({html: qrcodeimg});
        }).catch(function (err) {
            
        })
    }

    copy_link() {
        var self = this;

        self.get_short_url().then(function (data) {
            // console.log(data);
            self.set_clipboard_text(data);
        }).catch(function (err) {
            
        })
    }

    set_clipboard_text(text) {
        var id = "mycustom-clipboard-textarea-hidden-id";
        var existsTextarea = gid(id);

        if (!existsTextarea) {
            var textarea = document.createElement("textarea");
            textarea.id = id;
            // Place in top-left corner of screen regardless of scroll position.
            textarea.style.position = 'fixed';
            textarea.style.top = 0;
            textarea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textarea.style.width = '1px';
            textarea.style.height = '1px';

            // We don't need padding, reducing the size if it does flash render.
            textarea.style.padding = 0;

            // Clean up any borders.
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';

            // Avoid flash of white box if rendered for any reason.
            textarea.style.background = 'transparent';
            document.querySelector("body").appendChild(textarea);
            existsTextarea = gid(id);
        }

        existsTextarea.value = text;
        existsTextarea.select();

        try {
            var status = document.execCommand('copy');
            if (!status) {
                console.error("Cannot copy text");
            } else {
                alert(texts.linkgekopieerdtext);
            }
        } catch (err) {
            
        }
    }

    async get_data_pdf() {
        // Let Three.js finish a frame so the 2D preview is painted before capture.
        await new Promise(function (resolve) {
            requestAnimationFrame(function () {
                requestAnimationFrame(resolve);
            });
        });

        var images = { prtscrn: '' };
        var sp = new save_pics('container_2d_three');

        if (sp.canvas && sp.canvas.width > 0 && sp.canvas.height > 0) {
            /*
            Now fix the problem that if we take a print screen from the three.js canvas, the measures
            are not there, because they are in a separate div with labels generated by CSS2DObject
             */
            var combinedCanvas = document.createElement('canvas');
            combinedCanvas.width = sp.canvas.width;
            combinedCanvas.height = sp.canvas.height;
            var combinedCtx = combinedCanvas.getContext('2d');

            combinedCtx.fillStyle = "white";
            combinedCtx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);
            combinedCtx.drawImage(sp.canvas, 0, 0);

            var labels = $("#container_2d_three div.label");
            var positions, x_pos, y_pos, content, color, height, width, bg_color;
            for (var i = 0; i < labels.length; i++) {
                content = labels[i].innerHTML;
                content = content.replace(/<font[^>]*>/gi, '');
                content = content.replace(/<\/font>/gi, '');

                positions = $(labels[i]).css("transform").replace("matrix(", "").replace(")", "").split(",");
                x_pos = positions[4].replace(" ", "") * 1;
                y_pos = positions[5].replace(" ", "") * 1;
                color = $(labels[i]).css("color");
                height = parseInt($(labels[i]).css("height"), 10);
                width = parseInt($(labels[i]).css("width"), 10);
                bg_color = $(labels[i]).css("background-color");

                this.drawTextBG(combinedCtx, content, "bold " + $(labels[i]).css("font-size") + " " + ($(labels[i]).css("font-family") || "sans-serif"), x_pos, y_pos, color, width, height, bg_color);
            }

            images.prtscrn = combinedCanvas.toDataURL('image/png');
        } else {
            console.warn('[configurator datasheet] 2D canvas not ready; PDF will omit the large drawing.');
        }

        var datatosend = {
            'action': "configurator_datasheet",
            'security': texts.security,
            'images': JSON.stringify(images),
            'config_url': this.get_long_url(),
            'mounting_parts': JSON.stringify([cf.mp_cyl.hahntype, cf.mp_rod.hahntype]),
            'mounting_cad_urls': JSON.stringify({
                cyl: (cf.mp_cyl && cf.mp_cyl.cad_array) ? cf.mp_cyl.cad_array : [],
                rod: (cf.mp_rod && cf.mp_rod.cad_array) ? cf.mp_rod.cad_array : []
            }),
            'ids': JSON.stringify([cf.mp_cyl.woo_id, cf.gs.woo_id, cf.mp_rod.woo_id]),
        };

        jQuery.ajax({
            url: texts.ajaxurl,
            data: datatosend,
            type: 'post',
            success: function (response) {
                var url = (typeof response === 'string' ? response : '').trim();
                if (!url || url.indexOf('.pdf') === -1) {
                    console.error('[configurator datasheet] PDF generation failed:', response);
                    alert('Datasheet PDF could not be created. Check the browser console and PHP error log.');
                    return;
                }
                var link = document.createElement("a");
                link.download = texts.datasheet_file_name;
                link.href = url;
                link.click();
            },
            error: function (xhr, status, err) {
                console.error('[configurator datasheet] AJAX error:', status, err, xhr && xhr.responseText);
                alert('Datasheet PDF request failed.');
            }
        });
    }

    drawTextBG(ctx, txt, font, x, y, color, width, height, bg_color) {

        /// lets save current state as we make a lot of changes
        ctx.save();

        /// set font
        ctx.font = font;

        /// draw text from top - makes life easier at the moment
        ctx.textBaseline = 'top';

        /// color for background
        ctx.fillStyle = bg_color;
        ctx.fillRect(x, y, width, height);

        /// text color
        ctx.fillStyle = color;

        /// get width of text
        var text_width = ctx.measureText(txt).width;

        /// draw text on top
        ctx.fillText(txt, x + (width - text_width) / 2, y + height / 4);

        /// restore original state
        ctx.restore();
    }

    set_listeners() {
        var self = this;
        $(".configurator-actions a.action").on('click', function (e) {

            e.preventDefault();

            switch ($(this).data('action')) {
                case 'email':
                    self.do_email();
                    return false;
                    break;
                case 'link':
                    self.copy_link();
                    break;
                case 'pdf':
                    self.get_data_pdf();
                    break;
                case 'qrcode':
                    self.show_qr_code();
                    break;
            }

            return false;
        });
    }


}
